import { Component, OnInit } from '@angular/core';
import { HospitalityService } from 'src/app/shared/services/hospitality.service';

@Component({
  selector: 'app-matchday-program',
  templateUrl: './matchday-program.component.html',
  styleUrls: ['./matchday-program.component.scss']
})
export class MatchdayProgramComponent implements OnInit {

  matchdayRequest: any = {
    pagesize: -1,
      page: 1,
  };
  hospitalityList: any = "";
  slidematchdayprogramConfig = {
    //dots: true,
    infinite:false,
    arrows:true,
    slidesToShow: 4,
    slidetoscorll:1,
    autoplay:true,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  constructor(
    public hospitalityService: HospitalityService
  ) { }

  ngOnInit() {
    let request = Object.assign({}, this.matchdayRequest)
    this.hospitalityService.getMatchdayProgram(request).then((data) => {
      this.hospitalityList = data;
      console.log(this.hospitalityList);
      
    });

  }

}
